import { ReactNode } from 'react';

import styled from 'styled-components';

import { Button } from '@components/button';
import { IconRemove } from '@components/icons/remove';
import { IconReplace } from '@components/icons/replace';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';

import { FilterListSeparator } from './list-separator';
import { CurrentFilterActions, CurrentFilterState } from './use-current-filter';

export const FilterActionButtons = (props: {
  applyFilterText?: string;
  updateFilterText?: string;
  removeFilterText?: string;
  disableApply: boolean;
  state: CurrentFilterState;
  actions: CurrentFilterActions;
}) => {
  const { t } = useScopedTranslate(locale);
  const {
    applyFilterText = t('apply'),
    removeFilterText = t('remove'),
    updateFilterText = t('update'),
    disableApply,
    state,
    actions,
  } = props;
  const isEditing = state.id !== undefined;

  if (!isEditing) {
    return (
      <FiltersActionsGroup>
        <Button
          size="sm"
          isDisabled={disableApply}
          variant="primary"
          text={applyFilterText}
          onClick={() => {
            actions.applyFilter();
          }}
        />
      </FiltersActionsGroup>
    );
  }

  return (
    <FiltersActionsGroup>
      <Button
        size="sm"
        variant="secondary"
        iconLeft={<IconRemove />}
        text={removeFilterText}
        onClick={() => {
          actions.removeFilter();
        }}
      />

      <Button
        size="sm"
        isDisabled={disableApply}
        variant="primary"
        text={updateFilterText}
        iconLeft={<IconReplace />}
        onClick={() => {
          actions.applyFilter();
        }}
      />
    </FiltersActionsGroup>
  );
};

function FiltersActionsGroup(props: { children: ReactNode }) {
  return (
    <FiltersActionsGroupContainer space={4}>
      <FilterListSeparator />
      <Stack orientation="horizontal" space={2} align="center" justify="flex-end">
        {props.children}
      </Stack>
    </FiltersActionsGroupContainer>
  );
}

const FiltersActionsGroupContainer = styled(Stack)({
  position: 'sticky',
  bottom: '-1rem',
  zIndex: 999,
  padding: '0rem 1rem 1rem 1rem',
  margin: '1rem -1rem -1rem -1rem',
  '> div:first-child': {
    margin: 0,
  },
  background: theme.color.backgroundLightDark,
});

const locale = {
  en: {
    remove: 'Remove',
    apply: 'Apply',
    update: 'Update',
  },
  is: {
    remove: 'Fjarlægja',
    apply: 'Bæta við',
    update: 'Uppfæra',
  },
};
